import * as React from 'react';

import StateMissingFallback from '../components/StateMissingFallback';

/**
 * 등록되지 않은 주소로 들어왔을 때.
 *
 * 배포는 `serve -s build` 라 존재하지 않는 경로에도 200 + index.html 을 준다.
 * 그래서 오타·구버전 딥링크·바뀐 주소로 들어오면 404 조차 아니고, 라우트가
 * 하나도 맞지 않아 **아무것도 렌더되지 않은 빈 페이지**가 남았다.
 *
 * 안내와 함께 하단 탭을 보여주는 기존 컴포넌트를 그대로 쓴다.
 */
const NotFound = () => (
  <StateMissingFallback
    title="페이지를 찾을 수 없습니다"
    message={'요청하신 주소를 찾을 수 없습니다.\n주소가 바뀌었거나 삭제된 화면일 수 있습니다.'}
    actionLabel="홈으로"
    to="/"
  />
);

export default NotFound;
